
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue';
import CrossIconBlackNew from '@/components/icons/CrossIconBlackNew.vue';
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';

@Component({
	components: {
		ArrowLeftIcon,
		CrossIconBlackNew,
	},
})
export default class InvoiceHeader extends Vue {
	@Emit('back') goBack() {}
	@Emit('close') close() {}
  @Prop({ type: String, required: false }) message!: 'Submit an invoice';
}
